import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/regulatory-affairs/combination-products")({
  head: () =>
    buildRouteHead("/zh-cn/services/regulatory-affairs/combination-products", { noIndex: true }),
  beforeLoad: () => {
    // Mirrors the English route: combination products live under Industries.
    throw redirect({ to: "/zh-cn/industries/combination-products", replace: true });
  },
});
